import CardDiv from "modules/common/card-div/CardDiv";
import PaginationDiv from "modules/pagination/PaginationDiv";
import TransferTable from "modules/recent_transfer/TransferTable";
import { useRecentTransfer } from "modules/recent_transfer/store";
import React, { useEffect, useState } from "react";

function RecentTransfer() {
  const { transferData, transferLoading, fetchTransferData } =
    useRecentTransfer();

  const [page, newPage] = useState(1);
  const [transferFilterData, setTransferFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [transferSortedData, setTransferSortedData] = useState([]);
  useEffect(() => {
    fetchTransferData();
  }, []);

  useEffect(() => {
    setTransferSortedData(transferData);
  }, [transferData]);

  useEffect(() => {
    async function calculate() {
      const numOfSubarrays = Math.max(
        Math.ceil((transferSortedData?.length || 0) / 10),
        0
      );

      const paginationArrays = transferSortedData
        ? Array.from({ length: numOfSubarrays }, (_, index) => {
            const start = index * 10;
            const end = start + 10;
            return transferSortedData?.slice(start, end);
          })
        : [];
      setPageCount(
        Math.min(Math.ceil((transferSortedData?.length || 0) / 10), 100)
      );
      setTransferFilter(paginationArrays[page - 1]);
    }
    calculate();
  }, [transferSortedData, page]);

  return (
    <div>
      <CardDiv
        title={<div className="fs-2">Recent Transfer</div>}
        component={
          <div>
            <div>
              <TransferTable
                transferFilterData={transferFilterData}
                transferLoading={transferLoading}
              />
            </div>
            <div>
              <PaginationDiv
                newPage={newPage}
                paginationData={{
                  pageCount: pageCount || 1,
                  page: page,
                }}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default RecentTransfer;
